;(function () {
  angular
    .module('contrast.license')
    .directive('csUnlicensedText', csUnlicensedText)

  function csUnlicensedText() {
    return {
      replace: true,
      restrict: 'A',
      bindToController: {
        csUnlicensedText: '@'
      },
      scope: {},
      controller: function controller() {
        var vm = this

        angular.extend(vm, {
          getClass: getClass
        })

        function getClass() {
          var context = vm.csUnlicensedText
          if (typeof context !== 'undefined') {
            switch (context) {
              case 'tooltipTitle':
                return 'cs-unlicensed-text-tooltip'
              case 'link':
                return 'cs-unlicensed-text-link'
              case 'disabled':
                return 'cs-unlicensed-text-disabled'
              default:
                return undefined
            }
          }
        }
      },
      controllerAs: 'ctrl',
      templateUrl: 'components/license/cs-unlicensed-text.html'
    }
  }
})()
